import { render } from "./view.vue?vue&type=template&id=7bb1b6f9&ts=true"
import script from "./view.vue?vue&type=script&lang=ts"
export * from "./view.vue?vue&type=script&lang=ts"

import "./view.vue?vue&type=style&index=0&id=7bb1b6f9&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Pages/Admin/Teams/view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bb1b6f9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bb1b6f9', __exports__)) {
    api.reload('7bb1b6f9', __exports__)
  }
  
  module.hot.accept("./view.vue?vue&type=template&id=7bb1b6f9&ts=true", () => {
    api.rerender('7bb1b6f9', render)
  })

}


export default __exports__